const data = [
  {
    _id: 12,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703592058798-image11.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id:11 ,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703592044830-image10.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 10,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703592004442-image9.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 9,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703591979951-image8.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 8,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703591956925-image7.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 7,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703591936696-image6.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 6,
    title: "GIM 2023",
    identifier: "gallery_gim_2023",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703591911597-image5.jpg",
    date: "2023-09-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 5,
    title: "Asst Baord Aptitude",
    identifier: "gallery_asstboardapti",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703591737814-image5.jpg",
    date: "2023-07-30T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 4,
    title: "AI/ML Session",
    identifier: "gallery_aiml_session",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703583865932-image4.jpg",
    date: "2023-08-04T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 3,
    title: "AI/ML Session",
    identifier: "gallery_aiml_session",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703583847892-image3.jpg",
    date: "2023-08-04T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 2,
    title: "Army officer Session",
    identifier: "gallery_army_officer_session",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703583746003-image2.jpg",
    date: "2023-07-01T00:00:00.000Z",
    __v: 0,
  },
  {
    _id: 1,
    title: "Main board declaration 23-24",
    identifier: "gallery_asstboarddeclare_23_24",
    imageLink:
      "https://saitmainwebsite.s3.ap-south-1.amazonaws.com/Images/1703583488450-image1.jpg",
    date: "2023-06-16T00:00:00.000Z",
    __v: 0,
  },
];

export default data;
